// extracted by mini-css-extract-plugin
export var dayLabel = "_ks-0";
export var pickerDisabled = "_ks-1";